import React, { useState } from "react";
import { Outlet } from "react-router-dom";


import "./layout.css";
import TopBar from "../TopBar/TopBar";
import Footer from "../Footer/Footer";
const Layout = () => {
  return (
    <div className="layout-page">
      <TopBar />
      <div className="wrapper">
        <div
          id="content"
        >
          <Outlet />
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default Layout;
